<template>
  <detailTemplate :classCustom="'detail-docs extend-detail'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>
      <div class="header flex-row">
        <el-tag size="mini" class="priority lv2">Đang xử lý</el-tag>
      </div>
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-bottom-10 margin-top-10"
          >Chi tiết quy trình</div>
          <div class="margin-top-10">
            <span class="label-input">Cấp quy trình:</span>
            <span class="font-weight__bold">{{deptId}}</span>
          </div>
          <div class="margin-top-10">
            <span class="label-input">Mã quy trình:</span>
            <span class="font-weight__bold">{{flowCode}}</span>
          </div>

          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form inline-message>
              <div class="group__info margin-top-10 padding-bottom-10">
                <div class="content">
                  <div class="form-input">
                    <div
                      class="title font-size__medium font-weight__bold margin-bottom-10"
                    >THÔNG TIN PHÂN QUYỀN</div>
                    <el-table
                      :data="stateToStates"
                      style="width: 100%"
                    >
                      <el-table-column
                        label="ĐƠN VỊ"
                      >
                        <template slot-scope="scope">
                          <div>{{scope.row.deptName}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="VAI TRÒ"
                      >
                        <template slot-scope="scope">
                          <div>{{scope.row.roleName}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="HÀNH ĐỘNG"
                      >
                        <template slot-scope="scope">
                          <div>{{scope.row.actionName}}</div>
                          <div>{{"(" + scope.row.actionCode + ")"}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="TRẠNG THÁI"
                      >
                        <template slot-scope="scope">
                          <div>{{scope.row.fromStateCode}}</div>
                          <div>{{scope.row.toStateCode}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label=""
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            class="addDocs color__red btn-none__border"
                            @click="deleteStateToState(scope.row)"
                          >
                            <i class="fas fa-times-circle font-size__small"></i>
                            &nbsp;Xóa
                          </el-button>
                        </template>
                      </el-table-column>

                    </el-table>
                    <br>
                    <div v-if="flow != null"
                      class="title font-size__medium font-weight__bold margin-bottom-10"
                    >THAO TÁC PHÂN QUYỀN</div>

                    <el-form-item class="custom-label__input width25" prop="listCVDV" v-if="flow != null">
                      <span class="label-input">Vai trò khởi tạo</span>
                      <div class="has-border__bottom font-size__small select100">
                        <el-select
                          class="style-fullWidth input-none__border"
                          v-model="listRequestRoles"
                          size="small"
                          filterable
                          placeholder
                          multiple
                        >
                          <el-option
                            v-for="item in listRoles"
                            :key="item.id"
                            :label="item.roleName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="listCVDV" v-if="flow != null">
                      <span class="label-input">Đơn vị</span>
                      <div class="has-border__bottom font-size__small select100">
                        <el-select
                          class="style-fullWidth input-none__border"
                          v-model="listRequestDepts"
                          size="small"
                          filterable
                          placeholder
                          multiple
                        >
                          <el-option
                            v-for="item in listDepartments"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>

                    <br><br><br>

                    <el-form-item class="custom-label__input width25" prop="listCVDV" v-if="flow != null">
                      <span class="label-input">Vai trò phê duyệt</span>
                      <div class="has-border__bottom font-size__small select100">
                        <el-select
                          class="style-fullWidth input-none__border"
                          v-model="listApproveRoles"
                          size="small"
                          filterable
                          placeholder
                          multiple
                        >
                          <el-option
                            v-for="item in listRoles"
                            :key="item.id"
                            :label="item.roleName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="listCVDV" v-if="flow != null">
                      <span class="label-input">Đơn vị</span>
                      <div class="has-border__bottom font-size__small select100">
                        <el-select
                          class="style-fullWidth input-none__border"
                          v-model="listApproveDepts"
                          size="small"
                          filterable
                          placeholder
                          multiple
                        >
                          <el-option
                            v-for="item in listDepartments"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>

                    <br><br><br>

                    <el-form-item class="custom-label__input width25" prop="listCVDV" v-if="flow != null">
                      <span class="label-input">Vai trò lãnh đạo</span>
                      <div class="has-border__bottom font-size__small select100">
                        <el-select
                          class="style-fullWidth input-none__border"
                          v-model="listLdRoles"
                          size="small"
                          filterable
                          placeholder
                          multiple
                        >
                          <el-option
                            v-for="item in listRoles"
                            :key="item.id"
                            :label="item.roleName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="listCVDV" v-if="flow != null">
                      <span class="label-input">Đơn vị</span>
                      <div class="has-border__bottom font-size__small select100">
                        <el-select
                          class="style-fullWidth input-none__border"
                          v-model="listLdDepts"
                          size="small"
                          filterable
                          placeholder
                          multiple
                        >
                          <el-option
                            v-for="item in listDepartments"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-form-item>
                    <br>
                    <div>{{responseData}}</div>
                  </div>

                </div>
              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>
      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              v-if="flow == null"
              size="mini"
              class="addDocs color__blue btn-none__border"
              @click="createFlow()"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i>
              &nbsp;Tạo quy trình
            </el-button>

            <el-button
              v-if="flow != null && listDepartments.length > 1"
              size="mini"
              class="addDocs color__blue btn-none__border"
              @click="addRoleToFlowToRequest()"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i>
              &nbsp;Thêm vai trò khởi tạo
            </el-button>

            <el-button
              v-if="flow != null && listDepartments.length > 1"
              size="mini"
              class="addDocs color__blue btn-none__border"
              @click="addRoleToFlowToApprove()"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i>
              &nbsp;Thêm vai trò phê duyệt
            </el-button>

            <el-button
              v-if="flow != null && listDepartments.length > 1"
              size="mini"
              class="addDocs color__blue btn-none__border"
              @click="addRoleToFlowToLd()"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i>
              &nbsp;Thêm vai trò LĐ
            </el-button>
            <el-button
              size="mini"
              class="addDocs color__red btn-none__border"
              @click="clearForm()"
            >
              <i class="fas fa-times-circle font-size__small"></i>
              &nbsp;Reset
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </detailTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import hanhchinhService from "../../../services/hanhchinhService";
import { EventBus } from "../../../event-bus.js";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
export default {
  name: "dangkyphonghopDetail",
  mixins: [handleRequestErrorMixin],
  components: {
    VuePerfectScrollbar,
    detailTemplate: () => import("../../common/detail.vue"),
    Multiselect: () => import("vue-multiselect")
  },

  created() {
    this.initPage();
  },

  computed: {
    flowCode() {
      return this.$route.params.flowCode;
    },

    deptId() {
      return this.$route.params.deptId;
    }
  },

  watch: {
    caseMasterId() {
      this.initPage();
    },

    deptId() {
      this.initPage();
    }
  },

  data() {
    return {
      listRoles: [],
      listDepartments: [],
      stateToStates: [],
      flow:null,

      listRequestRoles: [],
      listApproveRoles: [],
      listLdRoles: [],

      listRequestDepts: [],
      listApproveDepts: [],
      listLdDepts: [],

      responseData: null
    };
  },
  methods: {
    hashCode(str) { // java String#hashCode
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    },

    intToRGB(i) {
      var c = (i & 0x00FFFFFF)
          .toString(16)
          .toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
    },
    colorStyle(str) {
      let colors = ["#ffff83", "#0000FF", "#ff7972", "#00FF00", "#00FF00"];
      let hashCode = this.hashCode(str) > 0 ? this.hashCode(str) : this.hashCode(str) * -1;
      console.log(hashCode);
      let colorIndex = hashCode % 5;
      return "background: " + colors[colorIndex] + ";";
    },

    initPage() {
      this.listRequestDepts = [];
      this.listApproveDepts = [];
      this.listLdDepts = [];

      this.getRoles();
      this.getDepartments();
      this.getStateToStates();
      this.getFlow();

    },

    backListPage() {
      this.$router.push({
        name: "administration-tools",
        query: this.$route.query,
        params: this.$route.params
      });
    },

    getRoles() {
      hanhchinhService.getRoles().then(respone => {
        this.listRoles = respone.data;
      });
    },

    getDepartments() {
      hanhchinhService.getDepartmentsByParentId(this.deptId).then(respone => {
        this.listDepartments = respone.data.departments;
      });
    },

    getStateToStates() {
        hanhchinhService.getStateToStates(this.flowCode, this.deptId).then(respone => {
            this.stateToStates = respone.data.stateToStates;
        });
    },

    getFlow() {
        hanhchinhService.getFlow(this.flowCode, this.deptId).then(respone => {
            this.flow = respone.data.flow;
        });
    },

    createFlow() {
      let requestRoles = [];
      for (let i=0; i<this.listRequestRoles.length; i++) {
        for (let j=0; j<this.listRequestDepts.length; j++) {
          let role = {
            userId: null,
            roleId: this.listRequestRoles[i],
            deptId: this.listRequestDepts[j]
          };
          requestRoles.push(role);
        }
      }

      let approveRoles = [];
      for (let i=0; i<this.listApproveRoles.length; i++) {
        for (let j=0; j<this.listApproveDepts.length; j++) {
          let role = {
            userId: null,
            roleId: this.listApproveRoles[i],
            deptId: this.listApproveDepts[j]
          };
          approveRoles.push(role);
        }
      }

      let ldRoles = [];
      for (let i=0; i<this.listLdRoles.length; i++) {
        for (let j=0; j<this.listLdDepts.length; j++) {
          let role = {
            userId: null,
            roleId: this.listLdRoles[i],
            deptId: this.listLdDepts[j]
          };
          ldRoles.push(role);
        }
      }

      let form = {
        "flowCode": this.flowCode,
        "deptId": this.deptId,
        "listRequestRoles": requestRoles,
        "listApproveRoles": approveRoles,
        "listLdRoles": ldRoles
      };

      this.$confirm("Bạn có chắc muốn tạo quy trình không?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        this.responseData = null;
        hanhchinhService.createFlow(form).then(respone => {
          this.responseData = respone.data;
          this.initPage();
          EventBus.$emit("reloadPage", {});
        }).catch(error => {
          this.responseData = error.response.data;
          this.commonHandleRequestError(error)
        });
      }).catch(() => {});
    },

    deleteStateToState(row) {
        let form = {
            stateToStateId : row.id
        };

        this.$confirm("Bạn có chắc muốn xóa quyền không?", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy bỏ",
            type: "warning"
        }).then(() => {
            this.responseData = null;
            hanhchinhService.deleteStateToState(form).then(respone => {
                this.responseData = respone.data;
                this.getStateToStates();
            }).catch(error => {
                this.responseData = error.response.data;
                this.commonHandleRequestError(error)
            });
        }).catch(() => {});
    },

    addRoleToFlowToRequest() {
      let requestRoles = [];
      for (let i=0; i<this.listRequestRoles.length; i++) {
        for (let j=0; j<this.listRequestDepts.length; j++) {
          let role = {
            userId: null,
            roleId: this.listRequestRoles[i],
            deptId: this.listRequestDepts[j]
          };
          requestRoles.push(role);
        }
      }

      let form = {
        "flowCode": this.flowCode,
        "deptId": this.deptId,
        "listRequestRoles": requestRoles
      };

      this.$confirm("Bạn có chắc muốn thêm vai trò để khởi tạo quy trình không?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        this.responseData = null;
        hanhchinhService.addRoleToFlowToRequest(form).then(respone => {
          this.responseData = respone.data;
          this.getStateToStates();
        }).catch(error => {
          this.responseData = error.response.data;
          this.commonHandleRequestError(error)
        });
      }).catch(() => {});
    },

    addRoleToFlowToApprove() {
      let approveRoles = [];
      for (let i=0; i<this.listApproveRoles.length; i++) {
        for (let j=0; j<this.listApproveDepts.length; j++) {
          let role = {
            userId: null,
            roleId: this.listApproveRoles[i],
            deptId: this.listApproveDepts[j]
          };
          approveRoles.push(role);
        }
      }

      let form = {
        "flowCode": this.flowCode,
        "deptId": this.deptId,
        "listApproveRoles": approveRoles
      };

      this.$confirm("Bạn có chắc muốn thêm vai trò phê duyệt quy trình không?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        this.responseData = null;
        hanhchinhService.addRoleToFlowToApprove(form).then(respone => {
          this.responseData = respone.data;
          this.getStateToStates();
        }).catch(error => {
          this.responseData = error.response.data;
          this.commonHandleRequestError(error)
        });
      }).catch(() => {});
    },

    addRoleToFlowToLd() {
      let ldRoles = [];
      for (let i=0; i<this.listLdRoles.length; i++) {
        for (let j=0; j<this.listLdDepts.length; j++) {
          let role = {
            userId: null,
            roleId: this.listLdRoles[i],
            deptId: this.listLdDepts[j]
          };
          ldRoles.push(role);
        }
      }

      let form = {
        "flowCode": this.flowCode,
        "deptId": this.deptId,
        "listLdRoles": ldRoles
      };

      this.$confirm("Bạn có chắc muốn thêm vai trò LĐ cho quy trình không?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        this.responseData = null;
        hanhchinhService.addRoleToFlowToLd(form).then(respone => {
          this.responseData = respone.data;
        }).catch(error => {
          this.responseData = error.response.data;
          this.commonHandleRequestError(error)
        });
      }).catch(() => {});
    },

    clearForm() {
      this.listRequestDepts = [];
      this.listApproveDepts = [];
      this.listLdDepts = [];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/tools/Tool_Detail.vue